import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
  wrapper: {
    position: "relative",
    width: "105%",
    left: "-10px",
    top: "-1px",
    marginBottom: "5px",
  },
  botColorLightBulb: { fill: theme.secondaryColor },
}));

export default () => {
  const styles = useStyles();

  return (
    <div className={styles.wrapper} title="Happy Holidays from Hyro!">
      <svg fill="none" viewBox="0 0 379 32" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M378 29C345.2 35.4 335.667 14.6667 335 3C304.6 40.6 273.667 17.6667 262 2C227.6 42.8 196.333 19 185 2C149.8 45.2 110.333 20 95 2C68 38 39.6667 17.3333 28 2C27.3333 11 20.8 29 0 29"
          stroke="#D0D0D0"
        />
        <circle cx="22.5" cy="17.5" r="4.5" fill="#00C7D3" />
        <circle cx="73.5" cy="19.5" r="4.5" fill="#A15AED" />
        <circle
          cx="118.5"
          cy="20.5"
          r="4.5"
          className={styles.botColorLightBulb}
        />
        <circle cx="161.5" cy="21.5" r="4.5" fill="#EE2C4F" />
        <circle cx="200.5" cy="17.5" r="4.5" fill="#00C7D3" />
        <circle
          cx="244.5"
          cy="17.5"
          r="4.5"
          className={styles.botColorLightBulb}
        />
        <circle cx="284.5" cy="19.5" r="4.5" fill="#A15AED" />
        <circle cx="321.5" cy="15.5" r="4.5" fill="#EE2C4F" />
        <circle cx="355.5" cy="27.5" r="4.5" fill="#00C7D3" />
      </svg>
    </div>
  );
};
